module.exports = __webpack_public_path__ + "img/xjxq.eb925099.png";